import { useState } from "react";
import { Modal, Row, Form, Col, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import toastService from "../../_services/toastService";
import MessageModal from "../_components/MessageModal";
import SatAPI from "../../_services/sat";

const api = SatAPI();

function RemoveModal({ data = {}, hideModal }) {
  const snapshot = useSelector(state => state.snapshot.fileName);

  const [messageModal, setMessageModal] = useState(null);

  const openMessageModal = (title, message) => {
    setMessageModal(
      <MessageModal
        hideModal={() => {
          setMessageModal(null);
        }}
        title={title}
        message={message}
        icon="fas fa-exclamation-triangle"
      />,
    );
  };

  const onFormSubmit = async e => {
    e.preventDefault();
    // Run checks before removal
    const taskAssignments = await api.getTaskAssignments(snapshot);
    let hasAssignment = false;

    if (taskAssignments.filter((assignment) => data.ID === assignment.taskID).length > 0) {
      hasAssignment = true;
    }

    if (hasAssignment) {
      openMessageModal("Toewijzingen bestaan nog", "Er bestaan nog toewijzingen voor deze taak. Verwijder alle toewijzingen alvorens de taak te verwijderen.")
    } else {
      try {
        if (data.ID) {
          await api.deleteTask(data.ID);
        }

        //api.createSnapshot();
        toastService.send({ title: "Verwijderd", message: "Taak is verwijderd" });
        hideModal();
      } catch (error) {
        toastService.send({ title: "An error occured", message: error });
      }
    }
  };
  return (
    <Modal
      show
      onHide={() => {
        hideModal();
      }}
      backdrop="static"
      keyboard={false}
      centered
      size="lg">
      {messageModal}
      <Modal.Header closeButton>
        <Modal.Title>Taak verwijderen?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={12}>
            <Form onSubmit={onFormSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Ben je zeker dat je de taak <span className="font-bold">{data.name}</span> wilt verwijderen?</Form.Label>
              </Form.Group>

              <Button variant="danger" type="submit" disabled={snapshot}>
                <span>
                  <i className="far fa-trash" />
                  &nbsp;Verwijder
                </span>
              </Button>
            </Form>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default RemoveModal;
